import { Component, EventEmitter, Input, OnChanges, Output, HostListener } from '@angular/core';
import { Store } from '@ngxs/store'
import { Subscription } from 'rxjs';

import { UtilService } from 'app/shared/util.service';
import { Hotel } from 'app/shared/model/hotel';
import { FollowupOnsite } from 'app/states/followup-onsite/followup-onsite.actions';
import { CurrentSurvey } from 'app/states/survey/models';
import { StoreCurrentSurvey } from 'app/states/survey/survey.actions';
import { SurveyWrapperService } from 'app/shared/surveys/survey-wrapper/survey-wrapper.service';


@Component({
    selector: 'mh-core-lib-survey-wrapper',
    templateUrl: './survey-wrapper.component.html',
    styleUrls: ['./survey-wrapper.component.scss'],
    standalone: false
})
export class CoreLibSurveyWrapperComponent implements OnChanges {

  @Input()
  productId;

  @Input()
  chain: Hotel[] = [];

  @Input()
  showOptionAll = true;

  @Input()
  listenCustomerSubscribe = true;

  @Input()
  forceHide = false;

  @Input() showSurveySelector = true

  @Input() showContent = true;

  @Input() multipleSelectionMode = false;

  @Output()
  currentSurveySetted = new EventEmitter<boolean>();

  waiting = true;
  isOpen = false;

  listSurveys: any[] = [];
  listTypes: any[] = [];
  selectedSurvey = 0;
  selectedSurveys: number[] = [];
  allSelected = false;

  customerSubscribe: Subscription;

  selectedType = 1;

  lastCustomerId = 0;

  @HostListener('document:click', ['$event'])
  onClick(event) {
    const result = this.checkClickInside(event.target);
    if (!result) {
      this.isOpen = false;
    }
  }

  actions   = {
    nps :          'getHistoricNPS',
    ranking:       'getTripAdvisor',
    pms:           'getHistoricPMS',
    sent:          'getEmailsArea',
    answered:      'getEmailsArea',
    rate:          'getEmailsArea',
    email_surveys: 'getEmailsArea',
    open_surveys:  'getEmailsArea',
    ranking_areas: 'getHistoricArea',
    total_guests: 'getHistoricPMS',
    promoters: 'getHistoricNPS',
    passives: 'getHistoricNPS',
    detractors: 'getHistoricNPS',
    survey_total_score: 'getScore',
    semantic_index: 'getSemanticIndex',
  };

  lists = [];
  currentSurvey;

  constructor(
    private utilService: UtilService,
    private surveyWrapperService: SurveyWrapperService,
    private store: Store) {
      this.customerSubscribe = this.utilService.isCustomerChanged().subscribe(response=>{
        if(this.listenCustomerSubscribe){
          if(this.lastCustomerId !== parseInt(this.utilService.currentHotel.id)){
            this.lastCustomerId = parseInt(this.utilService.currentHotel.id);
            this.getSurveys();
          }
        }
      })
    }

  ngOnChanges(changes): void {
    if(this.listenOnChanges && changes.chain && changes.chain.currentValue.length!==0 && !changes.chain.firstChange) this.getSurveys();
  }

  ngOnInit(){
    this.getSurveys();
  }

  ngOnDestroy(){
    this.customerSubscribe.unsubscribe();
  }

  setList(){
    this.lists = Object.keys(this.actions);
  }

  getSurveys(){
    this.waiting = true;
    this.getCustomerSurveys();
  }

  getCustomerSurveys(){
    const ids = this.isChain ? this.chain.map(x=>x.id).join(',') : this.utilService.currentHotel.id;
    const productId = this.productId === 5 ? 1 : this.productId;
    this.surveyWrapperService.getChainCustomerSurveys(ids,productId).subscribe((response:any)=>{
      this.listSurveys    = response || [];
      this.store.dispatch(new FollowupOnsite.StoreSurveys(this.listSurveys))
      
      if (this.multipleSelectionMode) {
        this.setSurveyTypes();
        if (this.isChain) {
          this.selectedSurveys = this.listTypes.map(type => type.type);
        } else {
          this.selectedSurveys = this.listSurveys.map(survey => survey.id);
        }
        this.allSelected = true;
        this.emitMultipleSelection();
      } else {
        if(!this.showOptionAll){
          this.selectedSurvey = this.isChain ? this.listSurveys[0].type.id : this.listSurveys[0].id;
        } else this.selectedSurvey = 0;
        this.setSurveyTypes();
        this.setCurrentSurvey(this.selectedSurvey)
      }
      
      this.waiting = false;
    })
  }

  setSurveyTypes(){
    this.listTypes = this.listSurveys.reduce((acc, curr) => {
      const id = curr.type.id;
      const version = curr.version;
      const translates = curr.translates;

      const survey = {
        type: id,
        version,
        translates,
      }

      const surveyFound = acc.find(surv => surv.type === id);
      if (!surveyFound) {
        acc = [...acc, survey]
      }
      return acc;
    }, [])
  }

  setCurrentSurvey(filter:number){
    if (!this.multipleSelectionMode) {
      this.isOpen = false;
      const surveys = filter === 0 ? this.listSurveys : this.selectSurveyByTypeOrId(this.isChain ? 'type' : 'id', filter);
      const ids = surveys.map(x=>x['id']).join(',');
      const currentSurvey = new CurrentSurvey(ids, surveys);
      this.currentSurvey = currentSurvey;
      this.store.dispatch(new StoreCurrentSurvey(currentSurvey));
      this.utilService.setCurrentSurvey(ids,surveys);
      this.currentSurveyUpdated();
    }
  }

  toggleSurveySelection(filter: number): void {
    if (!this.multipleSelectionMode) return;

    const index = this.selectedSurveys.indexOf(filter);
    
    if (index > -1) {
      this.selectedSurveys.splice(index, 1);
    } else {
      this.selectedSurveys.push(filter);
    }

    this.updateAllSelectedState();
    this.emitMultipleSelection();
  }

  selectAllSurveys(): void {
    if (!this.multipleSelectionMode) return;
    
    if (this.isChain) {
      this.selectedSurveys = this.listTypes.map(type => type.type);
    } else {
      this.selectedSurveys = this.listSurveys.map(survey => survey.id);
    }
    
    this.allSelected = true;
    this.emitMultipleSelection();
  }

  deselectAllSurveys(): void {
    if (!this.multipleSelectionMode) return;
    
    this.selectedSurveys = [];
    this.allSelected = false;
    this.emitMultipleSelection();
  }

  isSurveySelected(filter: number): boolean {
    return this.selectedSurveys.includes(filter);
  }

  private updateAllSelectedState(): void {
    if (this.isChain) {
      this.allSelected = this.selectedSurveys.length === this.listTypes.length;
    } else {
      this.allSelected = this.selectedSurveys.length === this.listSurveys.length;
    }
  }

  private emitMultipleSelection(): void {
    let surveys = [];
    
    if (this.selectedSurveys.length === 0) {
      surveys = this.listSurveys;
    } else {
      surveys = [].concat(...this.selectedSurveys.map(filter => 
        this.selectSurveyByTypeOrId(this.isChain ? 'type' : 'id', filter)
      ));
    }
    
    const ids = surveys.map(x => x['id']).join(',');
    const currentSurvey = new CurrentSurvey(ids, surveys);
    this.currentSurvey = currentSurvey;
    this.store.dispatch(new StoreCurrentSurvey(currentSurvey));
    this.utilService.setCurrentSurvey(ids, surveys);
    this.currentSurveyUpdated();
  }

  selectSurveyByTypeOrId(condition: 'id' | 'type', filter){
    if(condition==='type'){
      return this.listSurveys.filter(x=>x.type.id===filter);
    }else{
      return [this.listSurveys.find(x=>x.id===filter)];
    }
  }

  currentSurveyUpdated() {
    const waitForCurrentSurvey = false;
    this.currentSurveySetted.emit(waitForCurrentSurvey);
  }

  getSurveyName(id: number): string {
    const survey = this.listSurveys.find(s => s.id === id);
    if (!survey) return '';
    
    if (survey.version === 1) {
      return survey.type ? survey.type.id : '';
    } else {
      return this.getTranslatedTitle(survey.translates);
    }
  }

  getTypeName(typeId: number): string {
    const type = this.listTypes.find(t => t.type === typeId);
    if (!type) return '';
    
    if (type.version === 1) {
      return type.type.toString();
    } else {
      return this.getTranslatedTitle(type.translates);
    }
  }

  getTranslatedTitle(translates: any): string {
    if (!translates) return '';
    const lang = this.language;
    const translation = translates.find(t => t.language === lang);
    return translation?.title || '';
  }

  get isChain(){ return this.chain && this.chain.length>0}

  get showFilter(){ return this.isChain ? this.listTypes.length > 1 && !this.forceHide : this.listSurveys.length > 1 && !this.forceHide }

  get listenOnChanges() { return !this.listenCustomerSubscribe}

  get language() { return this.utilService.getCurrentLanguage() }

  get selectedCount(): number {
    return this.selectedSurveys.length;
  }

  get totalCount(): number {
    return this.isChain ? this.listTypes.length : this.listSurveys.length;
  }

  get selectedSurveyNames(): string[] {
    if (!this.multipleSelectionMode) return [];
    
    return this.selectedSurveys.map(filter => {
      if (this.isChain) {
        return this.getTypeName(filter);
      } else {
        return this.getSurveyName(filter);
      }
    });
  }

  checkClickInside(target) {
    if (target.id === 'surveyWrapperTrigger' || 
        target.id === 'surveyWrapperMenu' || 
        target.className?.includes('mat-radio') ||
        target.className?.includes('mat-checkbox') ||
        this.isChildOfElementWithId(target, 'surveyWrapperTrigger') ||
        this.isChildOfElementWithId(target, 'surveyWrapperMenu')) {
      return true;
    } else if (target.parentNode) {
      return this.checkClickInside(target.parentNode);
    } else {
      return false;
    }
  }

  isChildOfElementWithId(element, id) {
    let parent = element.parentNode;
    while (parent) {
      if (parent.id === id) {
        return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }

}
